import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Institutional Risk Assesments',
      type: 'table',
      watch: {
        '[]': [
          {
            '{}': {
              alias: 'sr.actions.save-risk-assessment',
            },
          },
        ],
      },
      content: {
        '{}': {
          query: {
            '`': {
              filter: {
                '=': [
                  {
                    '@.': '!id',
                  },
                  {
                    '@$': 'subrecipientId',
                  },
                ],
              },
              target: 'ent:!subrecips:!subrecip',
              quantity: 1,
              selection: {
                '@': 'snapshots',
              },
              subqueries: {
                snapshots: {
                  ref: {
                    attr: 'attr:snap#!subrecips#!subrecipient_risk_survey:!subj',
                  },
                  target: 'snap:!subrecips:!subrecipient_risk_survey',
                  selection: {
                    '{}': {
                      fields: {
                        '{}': {
                          when: {
                            '{}': {
                              value: {
                                '@.': '!when',
                              },
                            },
                          },
                          score: {
                            '{}': {
                              value: {
                                score: '*',
                              },
                            },
                          },
                        },
                      },
                      onClick: {
                        '{}': {
                          action: {
                            '{}': {
                              payload: {
                                '{}': {
                                  widget: {
                                    '{}': {
                                      alias:
                                        'sr.subrecipient-details.widgets.institutional-risk-assessment.survey',
                                    },
                                  },
                                  variables: {
                                    '{}': {
                                      isReadonly: true,
                                      assessmentId: {
                                        '@.': '!id',
                                      },
                                    },
                                  },
                                },
                              },
                              operation: 'ui.modal',
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'score',
                  direct: {
                    '{}': {
                      name: 'Risk Score',
                      type: 'TEXT',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'when',
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:snap#!subrecips#!subrecipient_risk_survey:!when',
                    },
                  },
                },
              },
            ],
          },
          onCreate: {
            '{}': {
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      widget: {
                        '{}': {
                          alias:
                            'sr.subrecipient-details.widgets.institutional-risk-assessment.survey',
                        },
                      },
                      variables: {
                        '{}': {
                          isReadonly: false,
                          subrecipientId: {
                            '@$': 'subrecipientId',
                          },
                        },
                      },
                    },
                  },
                  operation: 'ui.modal',
                },
              },
            },
          },
          noPagination: true,
        },
      },
    },
  },
}
